module.exports = __webpack_public_path__ + "static/media/contentTypeSelected.57dc9bc4.svg";